import { ensureBrowserAuthBootstrap, getBrowserAuthAccessToken } from './browser-auth'
import { getAuthApiBaseUrl } from './browser-utils'

const createAuthorizedRequestInit = async (init?: RequestInit): Promise<RequestInit | null> => {
  await ensureBrowserAuthBootstrap()
  const accessToken = await getBrowserAuthAccessToken()
  if (!accessToken) {
    return null
  }

  const headers = new Headers(init?.headers)
  headers.set('Authorization', `Bearer ${accessToken}`)
  if (init?.body) {
    headers.set('Content-Type', headers.get('Content-Type') ?? 'application/json')
  }

  return {
    ...init,
    headers,
  }
}

export const fetchBrowserApi = async (path: string, init?: RequestInit): Promise<Response | null> => {
  const authorizedInit = await createAuthorizedRequestInit(init)
  if (!authorizedInit) {
    return null
  }

  return await fetch(new URL(path, getAuthApiBaseUrl()), authorizedInit)
}
